import React, { useEffect, useRef, useState } from "react";
import Drawer from "@mui/material/Drawer";
import camera from "../assets/svg/camera.svg";
import {
  Box,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  IconButton,
  InputBase,
  OutlinedInput,
  Paper,
  Typography,
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import close from "../assets/svg/drawer_close.svg";
import * as Yup from "yup";
import { useFormik } from "formik";
import { db, storage } from "../firebaseConfig";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { toast } from "react-toastify";
import { packageHistory } from "./common/History/helper";
import { useDispatch, useSelector } from "react-redux";
import {
  getDetailsById,
  getLatestShelfPackage,
  getMasterData,
  getOnlySuites,
  updateMasterData,
  updateShelfPackageDetails,
} from "../helper/functions";
import { getNextPackageId } from "./common/helper";
import { setSelectedPackage } from "../store/commonSlice";
import CameraModal from "./CameraModal";
import { getDownloadURL, ref, uploadString } from "firebase/storage";
import { IoMdCloseCircleOutline } from "react-icons/io";

const initialValue = {
  brand: {
    brandName: "",
    brandLogo: "",
  },
  merchantIndicator: "",
  suiteNumber: "",
  isNoSuite: false,
  packageName: "",
  totalWeight: 0,
  shelfId: "",
  packagePhotos:[],
  dimensionL: 0,
  dimensionW: 0,
  dimensionH: 0,
};

const validationSchema = Yup.object().shape({
  // brand: Yup.object({
  //   brandName: Yup.string().required("Required"),
  //   brandLogo: Yup.string().required("Required"),
  // }),
  // merchantIndicator: Yup.string().required("Required"),
  // suiteNumber: Yup.string().when("isNoSuite", {
  //   is: false,
  //   then: () => Yup.string().required("Suite number is required"),
  //   otherwise: () => Yup.string().nullable(),
  // }),
  isNoSuite: Yup.boolean(),
  packageName: Yup.string().when("isNoSuite", {
    is: true,
    then: () => Yup.string().required("Package name is required"),
    // otherwise: () => Yup.string().nullable(),
  }),
  // packageTotalWeight: Yup.number().required("Required"),
  // shelfId: Yup.string().required("Required"),
  // dimensionL: Yup.number().required("Required"),
  // dimensionW: Yup.number().required("Required"),
  // dimensionH: Yup.number().required("Required"),
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
      "& .MuiMenuItem-root": {
        "&:hover": {
          backgroundColor: "lightgray !important",
        },
      },
    },
  },
};

const EditConsolidatedPackageDrawer = ({
  pageName,
  editPackage,
  open,
  onClose,
  collectionName,
  shipmentCollectionName,
  shipmentData,
}) => {
  console.log(pageName, "pageName");
  const dispatch = useDispatch();
  const [initialValues, setInitialValues] = useState(initialValue);
  const [loadingPackage, setLoadingPackage] = useState(false);
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openCameraModal, setOpenCameraModal] = useState(false);
  const [photos, setPhotos] = useState([]);
  const user = useSelector((state) => state.auth.value);
  const webcamRef = useRef(null);
  const {
    selectedRequest: userActiveData,
    selectedPackage: packageActiveData,
  } = useSelector((state) => state.common);
  console.log(packageActiveData, "editPackage in packageActiveData");

  const checkCamera = async () => {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const hasVideoInput = devices.some(
        (device) => device.kind === "videoinput"
      );
      return hasVideoInput;
    } catch (error) {
      console.error("Error checking for camera:", error);
      return false;
    }
  };

  const handleOpen = async () => {
      const checkForCamera = await checkCamera();
      if (checkForCamera) {
        setOpenCameraModal(true);
      } else {
        toast.error("No camera found");
      }
  };
  const handleClose = () => setOpenCameraModal(false);

  const handleCapture = async () => {
    console.log('hello capture')
      const imageSrc = webcamRef.current.getScreenshot();
      const storageRef = ref(storage, `packages/${new Date().getTime()}.jpg`);
      console.log(editPackageFormik.values.packagePhotos,"editPackageFormik.values.packagePhotos")
      try {
        setOpenCameraModal(false);
        setLoadingPackage(true);
        const snapshot = await uploadString(storageRef, imageSrc, "data_url");
        const downloadURL = await getDownloadURL(snapshot.ref);
        const updatedPhotos = [...photos, downloadURL];
        console.log(updatedPhotos,downloadURL,"updatedPhotosss");
        
        setPhotos(updatedPhotos);
        editPackageFormik.setFieldValue("packagePhotos", [downloadURL,...editPackageFormik.values.packagePhotos||[]]);
      } catch (error) {
        console.error("Error uploading image: ", error);
      } finally {
        setLoadingPackage(false);
      }
  };

  const handlePhotoDelete = (index) => {
    
    if(editPackageFormik.values.packagePhotos?.length > index){
      const updatedPhoto = photos?.filter((photo)=>photo!==editPackageFormik.values.packagePhotos[index])
      setPhotos(updatedPhoto);
    }
    const updatedPhotos = editPackageFormik.values.packagePhotos.filter((_, i) => i !== index);
    editPackageFormik.setFieldValue("packagePhotos", updatedPhotos);
  };

  useEffect(() => {
    const q = query(collection(db, "brands"));

    const unsubscribe = onSnapshot(
      q,
      (querySnapshot) => {
        const brandsArray = [];
        querySnapshot.forEach((doc) => {
          brandsArray.push({ id: doc.id, ...doc.data() });
        });
        setBrands(brandsArray);
      },
      (error) => {
        console.error("Error fetching brand data: ", error);
      }
    );

    return () => unsubscribe();
  }, []);
  console.log(editPackage, collectionName, "editPackage");
  // console.log(initialValues,"initialValues");

  useEffect(() => {
    const fetchPackageData = async () => {
      console.log(
        editPackage,
        collectionName,
        "data in EditPackageDrawer"
      );
      if (editPackage?.id) {
        const docRef = doc(db, collectionName, editPackage?.id);
        const querySnapshot = await getDoc(docRef);

        if (querySnapshot.exists()) {
          const data = querySnapshot.data();
          console.log(data,"data for packages images");
          setPhotos(data?.packageImages||[])
          setInitialValues({
            ...data,
            packagePhotos:data?.packagePhotos||[],
            brand: {
              brandName: data?.brand?.brandName || "",
              brandLogo: data?.brand?.brandLogo || "",
            },
            merchantIndicator: data.merchantIndicator || "",
            totalWeight: data.totalWeight || 0,
            shelfId: data.shelfId || "",
            dimensionL: data.dimensionL || 0,
            dimensionW: data.dimensionW || 0,
            dimensionH: data.dimensionH || 0,
          });
        } else {
          setInitialValues(initialValue);
          console.log("No such document!");
        }
      } else {
        setInitialValues(initialValue);
      }
    };
    fetchPackageData();
  }, [editPackage?.id, editPackage, collectionName]);

  const editPackageFormik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      console.log("Form values:", values);
      setLoading(true);
      try {
        console.log(values, "values in formik submit");
          const docRef = doc(
            db,
            "shelfConsolidatedPackages",
            editPackage?.id
          );
          console.log(photos, "photos >>>>");
          let updateData = {
            ...values,
            packageImages:photos
            // totalWeight: values.totalWeight,
          };
          await updateDoc(docRef, updateData);
          const updatedPackageDetails = await getDetailsById([{ key: "__name__", operator: "==", value: editPackage?.id }], "shelfConsolidatedPackages")
          dispatch(setSelectedPackage(updatedPackageDetails[0]));
          toast.success("Packaging updated successfully!");
          onClose();
        // }
      } catch (error) {
        console.error("Error updating document: ", error);
      } finally {
        setLoading(false);
      }
    },
  });
  console.log(editPackageFormik.errors);

  // console.log(editPackageFormik.values, "editPackageFormik");
  // console.log(editPackageFormik.errors, "editPackageFormik.errors");
  // console.log(editPackageFormik.touched, "editPackageFormik.touched");

  return (
    <Drawer
      variant="temporary"
      anchor="right"
      open={open}
      onClose={onClose}
      BackdropProps={{ sx: { background: "rgba(0, 0, 0, 0.5)" } }}
    >
      <Box sx={{ width: "500px" }}>
        <Box
          sx={{
            borderBottom: "1px solid #E5E5E8",
            paddingLeft: "20px",
            paddingTop: "20px",
            paddingBottom: "20px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h5" component="h5">
            Prepare Consolidation
          </Typography>
          <Box
            sx={{ paddingRight: "20px", cursor: "pointer" }}
            onClick={onClose}
          >
            <img src={close} alt="close" />
          </Box>
        </Box>
        <Box sx={{ minHeight: "84vh", borderBottom: "1px solid #E5E5E8" }}>
          <Box>
            <CameraModal
              open={openCameraModal}
              handleClose={handleClose}
              webcamRef={webcamRef}
              handleCapture={handleCapture}
            />
            <Box mb={3} ml={3}>
              <label
                style={{
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
              >
                Package images
              </label>
              <Box
                display="flex"
                flexWrap="wrap"
                sx={{
                  gap: "16px",
                  background: "white",
                  // minHeight: "100px",
                  // minWidth: "100px",
                  width: "fit-content",
                  padding: "16px",
                  borderRadius: "4px",
                  mt: 1,
                }}
              >
                {editPackageFormik.values.packagePhotos?.filter(url=>url!=="")?.map((photo, index) => (
                  <Box key={index} position="relative">
                    <img
                      src={photo}
                      alt={`Package ${index}`}
                      style={{
                        height: "auto",
                        width: "75px",
                        // objectFit: "cover",
                      }}
                    />
                    <IconButton
                      size="small"
                      color="error"
                      sx={{ position: "absolute", top: 0, right: 0 }}
                      onClick={() => handlePhotoDelete(index)}
                    >
                      <IoMdCloseCircleOutline fontSize="small" />
                    </IconButton>
                  </Box>
                ))}
                {loadingPackage && (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <CircularProgress size={20} />
                  </Box>
                )}
                {editPackageFormik.values.packagePhotos?.length < 4 &&
                  Array.from(
                    {
                      length:
                        4 - editPackageFormik.values.packagePhotos?.length || 0,
                    },
                    (_, index) => (
                      <Grid item key={index}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Box
                            onClick={handleOpen}
                            sx={{
                              backgroundColor: "#FAFAFA",
                              width: "66px",
                              height: "66px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              cursor: "pointer",
                            }}
                          >
                            <img src={camera} alt="camera" />
                          </Box>
                        </Box>
                      </Grid>
                    )
                  )}
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              paddingLeft: "20px",
              paddingTop: "20px",
            }}
          >
            <Typography variant="body1" fontWeight="bold">
              Merchant
            </Typography>
            <Box>
              {collectionName === "shelfConsolidatedPackages" ? (
                <span>{editPackage?.merchantCount}</span>
              ) : (
                <FormControl
                  sx={{
                    m: 1,
                    minWidth: 270,
                    minHeight: "35px",
                    marginLeft: "0px",
                  }}
                  size="small"
                >
                  <Select
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                    value={editPackageFormik.values.brand.brandName}
                    name="brand.brandName"
                    onChange={(e) => {
                      const selectedBrand = brands.find(
                        (brand) => brand.brandName === e.target.value
                      );
                      editPackageFormik.setFieldValue(
                        "brand.brandName",
                        selectedBrand?.brandName || ""
                      );
                      editPackageFormik.setFieldValue(
                        "brand.brandLogo",
                        selectedBrand?.brandLogo || ""
                      );
                    }}
                    renderValue={(selected) => {
                      if (!selected) {
                        return <em>Select Merchant</em>;
                      }
                      const selectedBrand = brands.find(
                        (brand) => brand.brandName === selected
                      );
                      return (
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <img
                            src={selectedBrand?.brandLogo}
                            alt="brandLogo"
                            width="20px"
                            style={{ marginRight: "10px" }}
                          />
                          {selectedBrand?.brandName}
                        </Box>
                      );
                    }}
                    MenuProps={MenuProps}
                  >
                    {brands.map((item, index) => (
                      <MenuItem
                        value={item.brandName}
                        key={index}
                        sx={{
                          "& .MuiMenuItem-root:hover": {
                            backgroundColor: "lightgray",
                          },
                        }}
                      >
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <img
                            src={item.brandLogo}
                            alt="brandLogo"
                            width="20px"
                            style={{ marginRight: "10px" }}
                          />
                          {item.brandName}
                        </Box>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            </Box>
          </Box>
          <Box
            sx={{
              paddingLeft: "20px",
              paddingTop: "10px",
            }}
          >
            <Typography variant="body1" fontWeight="bold">
              Merchant Indicator
            </Typography>
            <Box>
              {collectionName === "shelfConsolidatedPackages" ? (
                <span>{editPackage?.merchantIndicator || "-"}</span>
              ) : (
                <FormControl
                  sx={{
                    m: 1,
                    minWidth: 270,
                    minHeight: "35px",
                    marginLeft: "0px",
                  }}
                  size="small"
                >
                  <OutlinedInput
                    value={editPackageFormik.values.merchantIndicator}
                    name="merchantIndicator"
                    onChange={editPackageFormik.handleChange}
                  />
                </FormControl>
              )}
            </Box>
          </Box>
          {initialValues.isNoSuite && (
            <>
              <Box sx={{ paddingLeft: "20px" }}>
                <Typography variant="body1" fontWeight="bold">
                  Suite number
                </Typography>
                <Paper
                  component="form"
                  sx={{
                    p: "2px 4px",
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #E5E5E8",
                    width: 350,
                    height: 40,
                    marginTop: "10px",
                  }}
                >
                  <InputBase
                    sx={{ ml: 1, flex: 1 }}
                    placeholder="Suit Number... "
                    inputProps={{ "aria-label": "search" }}
                    size="small"
                    name="suiteNumber"
                    value={editPackageFormik.values.suiteNumber}
                    onChange={editPackageFormik.handleChange}
                    disabled={!!editPackageFormik.values.isNoSuite}
                  />
                </Paper>
                {editPackageFormik.errors.suiteNumber &&
                  editPackageFormik.touched.suiteNumber && (
                    <div style={{ color: "red", fontSize: "14px" }}>
                      {editPackageFormik.errors.suiteNumber}
                    </div>
                  )}
              </Box>
              <FormGroup
                sx={{
                  paddingLeft: "20px",
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      name="isNoSuite"
                      checked={editPackageFormik.values.isNoSuite}
                      onChange={editPackageFormik.handleChange}
                      // onChange={(e) => {
                      //   editPackageFormik.setFieldValue(
                      //     "isNoSuite",
                      //     e.target.checked
                      //   );
                      //   // editPackageFormik.setFieldValue("packageName", "");
                      //   // editPackageFormik.setFieldValue("suiteNumber", "");
                      // }}
                      disabled={!!editPackageFormik.values.suiteNumber}
                    />
                  }
                  label="No Suite"
                />
              </FormGroup>
            </>
          )}
          {initialValues.isNoSuite && editPackageFormik.values.isNoSuite && (
            <Box
              sx={{
                paddingLeft: "20px",
              }}
            >
              <Typography variant="body1" fontWeight="bold">
                Name on package
              </Typography>
              <Paper
                component="form"
                sx={{
                  p: "2px 4px",
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid #E5E5E8",
                  width: 350,
                  height: 40,
                  marginTop: "10px",
                }}
              >
                <InputBase
                  sx={{ ml: 1, flex: 1 }}
                  placeholder="Name on package... "
                  inputProps={{ "aria-label": "search" }}
                  size="small"
                  name="packageName"
                  value={editPackageFormik.values.packageName}
                  onChange={editPackageFormik.handleChange}
                />
              </Paper>
              {editPackageFormik.errors.packageName &&
                editPackageFormik.touched.packageName && (
                  <div style={{ color: "red", fontSize: "14px" }}>
                    {editPackageFormik.errors.packageName}
                  </div>
                )}
            </Box>
          )}
          <Box
            sx={{
              paddingLeft: "20px",
              paddingTop: "10px",
            }}
          >
            <Typography variant="body1" fontWeight="bold">
              Weight (lb)
            </Typography>
            <Box>
              <FormControl
                sx={{
                  m: 1,
                  minWidth: 270,
                  minHeight: "35px",
                  marginLeft: "0px",
                }}
                size="small"
              >
                <OutlinedInput
                  type="number"
                  name="totalWeight"
                  value={editPackageFormik.values.totalWeight}
                  onChange={editPackageFormik.handleChange}
                />
              </FormControl>
            </Box>
          </Box>
          <Box
            sx={{
              paddingLeft: "20px",
              paddingTop: "10px",
            }}
          >
            <Typography variant="body1" fontWeight="bold">
              Shelf ID
            </Typography>
            <Box>
              <FormControl
                sx={{
                  m: 1,
                  minWidth: 270,
                  minHeight: "35px",
                  marginLeft: "0px",
                }}
                size="small"
              >
                <OutlinedInput
                  name="shelfId"
                  value={editPackageFormik.values.shelfId}
                  onChange={editPackageFormik.handleChange}
                />
              </FormControl>
            </Box>
          </Box>
          <Box
            sx={{
              paddingLeft: "20px",
              paddingTop: "10px",
            }}
          >
            <Box>
              <Typography variant="body1" fontWeight="bold">
                Dimensions (cm)
              </Typography>
            </Box>
            <Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <FormLabel>L</FormLabel>
                <Box>
                  <FormControl
                    sx={{ m: 1, maxWidth: 50, minHeight: "35px" }}
                    size="small"
                  >
                    <OutlinedInput
                      type="number"
                      name="dimensionL"
                      value={editPackageFormik.values.dimensionL}
                      onChange={editPackageFormik.handleChange}
                    />
                  </FormControl>
                </Box>
                <FormLabel>W</FormLabel>
                <Box>
                  <FormControl
                    sx={{ m: 1, maxWidth: 50, minHeight: "35px" }}
                    size="small"
                  >
                    <OutlinedInput
                      type="number"
                      name="dimensionW"
                      value={editPackageFormik.values.dimensionW}
                      onChange={editPackageFormik.handleChange}
                    />
                  </FormControl>
                </Box>
                <FormLabel>H</FormLabel>
                <Box>
                  <FormControl
                    sx={{ m: 1, maxWidth: 50, minHeight: "35px" }}
                    size="small"
                  >
                    <OutlinedInput
                      type="number"
                      name="dimensionH"
                      value={editPackageFormik.values.dimensionH}
                      onChange={editPackageFormik.handleChange}
                    />
                  </FormControl>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
        <Button
          type="submit"
          variant="contained"
          onClick={editPackageFormik.handleSubmit}
          sx={{
            minWidth: "189px",
            position: "absolute",
            bottom: 20,
            right: 20,
            borderRadius: "4px",
          }}
          disabled={loading}
        >
          consolidate package
        </Button>
      </Box>
    </Drawer>
  );
};

export default EditConsolidatedPackageDrawer;
